import React from "react";
import clsx from "clsx";

import Portal from "../Portal";

import styles from "./ChatBubbleModal.module.scss";

export type Props = {
  className?: string;
  onClose: () => void;
  transparentBackDrop?: boolean;
  children: React.ReactNode;
};
const ChatBubbleModal = React.forwardRef<HTMLDivElement, Props>(
  ({ className, children, onClose, transparentBackDrop }, ref) => {
    return (
      <Portal>
        <div className={styles.modal}>
          <div
            className={clsx(
              styles.modal__backDrop,
              transparentBackDrop && styles.modal__transparentBackground,
            )}
            onClick={onClose}
          />

          <div ref={ref} className={clsx(styles.modal__content, className)}>
            <div className={styles.modal__tail} />
            {children}
          </div>
        </div>
      </Portal>
    );
  },
);

export default ChatBubbleModal;
